<template>
    <v-card class="comments custom-dailog">
        <v-card-title>
            {{RegionalViewConstants.REASON_HEADER}}
            <i class="fas fa-times" @click="closeDialog()" data-qe-id="closeCommentsDialogBoxIcon"></i>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs9 class="comments__error">
                    <v-flex v-if="showError">{{RegionalViewConstants.ERROR_OCCURRED}}</v-flex>
                </v-flex>
                <v-flex text-xs-right xs3 data-qe-id="CommentsTextLength">
                    {{commentText.length}} {{validationText}}
                </v-flex>
            </v-layout>

            <v-textarea
                :disabled="updateInProgress"
                data-qe-id="CommentsText"
                @paste="isPasted($event)"
                v-model="commentText"
                @keypress="textCountLimiter($event, commentText, waiverFormConstants.MAX_REASON_LENGTH)">
            </v-textarea>
        </v-card-text>
        <v-card-actions>
            <v-flex text-xs-right class="pt-2 pb-2 pl-1 pr-3">
                <v-btn
                    :disabled="updateInProgress"
                    data-qe-id="cancelCommentsDialogBoxBtn"
                    class="primary_btn transparent small"
                    @click="closeDialog()">{{actionConstants.CANCEL}}</v-btn>
                <v-btn
                    :disabled="disableUpdate"
                    :loading="updateInProgress"
                    data-qe-id="CommentsConfirmBtn"
                    class="primary_btn small"
                    @click="SaveRegionalOfficerComments()">{{actionConstants.SAVE}}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { appCommonConstants } from "../appCommon.constants";
    import { RegionalViewConstants, waiverFormConstants, actionConstants } from "./ChapterWaiver.constants";
    import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { textCountLimiter } from "../../common/utils/utils";

    export default {
        name: 'RegionalOfficerComments',
        created() {
            this.commentText = '';
        },
        data: () => {
            return {
                appCommonConstants,
                RegionalViewConstants,
                waiverFormConstants,
                showWaiver: false,
                actionConstants,
                commentText: '',
                showError: false,
                updateInProgress: false,
                disableCancelBtn: false,
                disableCommentTextField: false,
            };
        },
        props: {
            leadId: {
                type: String,
                required: true,
            },
            closeDialogBox: {
                type: Function,
                required: true,
            },
        },
        methods: {
            textCountLimiter,

            isPasted($event) {
                const text = $event.clipboardData.getData("text");
                if ((this.commentText.length + text.length) > this.waiverFormConstants.MAX_REASON_LENGTH) {
                    $event.preventDefault();
                    return true;
                }
            },

            async SaveRegionalOfficerComments() {
                this.updateInProgress = true;
                const req = {
                    leadId: this.leadId,
                    commentText: this.commentText,
                    communityId: this.$route.params.communityId,
                };
                await this.saveRegionalOfficerComments(req);
                this.showError = this.regionalCommentsErrorOccurred;
                if (this.regionalCommentsErrorOccurred) {
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                }
                this.resetCommentText();
                this.updateInProgress = false;
                if (this.regionalCommentSaved) {
                    this.closeDialog();
                    this.setVisibleProspect(null);
                    this.removeLeadFromWaiverList(this.leadId);
                }
            },

            ...mapActions({
                saveRegionalOfficerComments: `chapterWaiver/${storeAction.saveRegionalOfficerComments}`,
            }),
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                removeLeadFromWaiverList: `chapterWaiver/${storeMutation.removeLeadFromWaiverList}`,
            }),
            resetCommentText() {
                this.commentText = '';
            },
            closeDialog() {
                this.resetCommentText();
                this.closeDialogBox();
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                regionalCommentSaved: `chapterWaiver/${storeGetters.regionalCommentSaved}`,
                regionalCommentsErrorOccurred: `chapterWaiver/${storeGetters.regionalCommentsErrorOccurred}`,
            }),

            validationText() {
                return `${this.waiverFormConstants.OF} ${this.waiverFormConstants.MAX_REASON_LENGTH} ${this.waiverFormConstants.CHARACTERS}`;
            },

            disableUpdate() {
                const reason = this.commentText.trim();
                return this.commentText.length <= 0 || reason === "";
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .error {
        color: $ypo-deep-red;
    }

    .comments {
        &.custom-dailog {

            .v-card {
                &__text {
                    margin: 0px;
                    padding: 16px 16px 16px 16px;
                }
            }

            .v-card__title {
                color: $white;
                background: $ypo-blue;
                font-size: 19px;

                i {
                    color: $white;
                    padding: 2px 2px 0px 25px;
                    cursor: pointer;
                }
            }

        }

        &__error {
            color: $ypo-deep-red;
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .comments {

        .v-input__slot:before,
        .v-input__slot:after {
            display: none;
        }

        .v-text-field {
            padding: 0px;
            margin: 0px;
        }

        textarea {
            border: 1px solid $ypo-medium-gray;
            border-radius: 3px;
            color: $ypo-blue !important;
            padding: 10px 10px;
            font-size: 14px;
            transition: 0.3s all ease;

            &:focus {
                border: 1px solid rgba($ypo-cta, 0.7);
            }
        }

        .v-messages {
            display: none;
        }
    }
</style>
